import Api from 'libs/api/index';

class CVFilters extends Api {
  constructor() {
    super('cv/filters');
  }
}

export default CVFilters;
